var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('v-col',{staticClass:"col-xl-1 col-md-2 cols-4",attrs:{"cols":"4"}},[_c('div',{staticClass:"col-md-12"},[_c('h3',{staticClass:"form-title font"},[_vm._v("Vendors")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }